import { currentLocale, i18n } from './i18n'
import { ApiError, SYNTHETIC_CODES } from './api'

/**
 * Text of an API error in the UI language: the translation of its code in
 * the given namespace when there is one (its placeholders from the refusal's
 * details); else the server's message, which is
 * French, so only in French; else a generic message. Codes the client made up
 * (an HTML error page, an unreadable answer) never show as "HTTP 502".
 */
export function errorText(err: unknown, namespace: string, fallbackKey = 'common.error'): string {
  // A plain view of t/te: vue-i18n's generic signatures are too deep for the checker here.
  const { t, te } = i18n.global as unknown as { t: (key: string, params?: Record<string, unknown>) => string; te: (key: string) => boolean }
  if (err instanceof ApiError) {
    // The refusal's details fill its placeholders (« {max} numbers »): plain values only.
    const params = err.details && typeof err.details === 'object' && !Array.isArray(err.details)
      ? Object.fromEntries(Object.entries(err.details as Record<string, unknown>).filter(([, v]) => ['string', 'number'].includes(typeof v)))
      : {}
    if (te(`${namespace}.errors.${err.code}`)) return t(`${namespace}.errors.${err.code}`, params)
    // Some server messages are built from an exception: « Error: … ».
    const message = err.message.replace(/^Error:\s*/, '')
    if (message && !SYNTHETIC_CODES.has(err.code) && currentLocale() === 'fr') return message
  }
  return t(fallbackKey)
}
